<!-- breadcrumb -->
<div class="container marginMobile">
    <div class="col-sm-12 breadcrumb py-3 m-0">
      <a href="#">Produits promos</a>
    </div>
  </div>
  <!-- Fin breadcrumb -->
  <div class="container-fluid container-xl">
  <!-- sideBar -->
  <div class="row">
    <div class="col-12 filterBtn  text-center">
        <button type="button" class="filterMobile closeFilter" name="button" onclick="showFiltre()">Fermer le filtre <i class="fa fa-times" aria-hidden="true"></i>
      </button>
        <button type="button" class="filterMobile openFilter" name="button" onclick="showFiltre()">Filtrer <i class="fa fa-filter" aria-hidden="true"></i>
      </button>
    </div>
    <div class="col-12 col-md-4 col-xl-3 sideFiltre" id="sideFiltre">
      
      <button class="btn btn-primary titreSideBar brandcollapse" type="button" data-bs-toggle="collapse" data-bs-target="#fournisseur" aria-expanded="false" aria-controls="collapseExample">
          Fournisseur <i class="fa fa-chevron-right fa-rotate-90 categoryIcon" aria-hidden="true"></i>
      </button>
      <div class="collapse show" id="fournisseur">
        <div class="f3">
          <div class="list-group">
            <a  *ngFor="let fournisseur of fournisseursAll" class="list-group-item list-group-item-action">
               <input type="checkbox" name="fournisseurs" (change)="filtreByFournisseur($event)" [value]="fournisseur.TSICOD4" > {{ fournisseur.SEAKEY}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-8 col-xl-9">
      <div class="container-fluid container-md p-0">
        <div class="row">
          <div class="col-sm-12 triProducts mb-4 d-none ">
            Filtrez Par Prix De :
            <input type="number"  class="triPrix" placeholder="30">
            Dhs à
            <input type="number" class="triPrix" placeholder="300"> Dhs
            <button type="button"  name="button" class="btn triReset "><i class="fa fa-times" aria-hidden="true"></i>
Réinitialiser</button>

          </div>
          <!-- filtre show products -->
          <div class="col-sm-12 triProducts mb-4 text-end mt-5 mt-lg-0">
            <div class="triAffichage">
              Affichage :
              <select class="form-select selectAffichage" (change)="changeMax($event.target.value)" aria-label="Default select example">
                <option value="12">x 12 Produits</option>
                <option value="22">x 22 Produits</option>
                <option value="44">x 44 Produits</option>
                <option value="88">x 88 Produits</option>
              </select>
            </div>
          </div>
          <!-- list products -->
          <div class="flash text-center" *ngIf="!productByCategory">
            <img src="assets/front/images/logo.png"/>
          </div>
          <div class="col-6 col-md-6 col-lg-4" *ngFor="let product of productByCategory | paginate: {itemsPerPage: pageSize,currentPage: page,totalItems: total }">
            <app-card-product [product]="product" promos="true"></app-card-product>
          </div>


          <!-- <pagination-controls class="text-center" (pageChange)="onPageChange($event)"></pagination-controls> -->

          <nav aria-label="Page navigation example">
            <ul class="pagination justify-content-center">
              <li class="page-item"><a class="page-link" (click)="previousPage()">Previous</a></li>
              <li class="page-item" *ngFor="let pageNumber of pageNumbers" [class.active]="pageNumber == startIndex" (click)="goToPage(pageNumber)">
                <a class="page-link">{{ pageNumber }}</a>
              </li>
              <li class="page-item"><a class="page-link" (click)="nextPage()">Next</a></li>
            </ul>
          </nav>

        </div>
      </div>
    </div>
  </div>
  <!-- Fin sideBar -->
  </div>
